
import Tables from "layouts/tables";
import Popup from "layouts/tables/data/popup";
import SignUp from "layouts/authentication/sign-up";
import SignIn from "layouts/authentication/sign-up";
import OfferNewsList from "layouts/authentication/components/OfferNewsList";
import UserList from "layouts/authentication/components/UserList";
import UserCreate from "layouts/createUsers";
import GenresDisclaimer from "layouts/authentication/components/genresDisclaimer";
import ContactUs from "layouts/authentication/components/contactUs";
import SetMargin from "layouts/authentication/setMargin";
import SetUsdPrice from "layouts/authentication/setUsdPrice";
import Region from "layouts/Region";
import { Navigate } from "react-router-dom";

// @mui icons
import Icon from "@mui/material/Icon";
import CarrieirPage from "layouts/authentication/carreirPage";
import SignUpUserList from "layouts/authentication/components/signUpFormList";
import Basic from "layouts/authentication/sign-in";
import SecondSignUp from "layouts/authentication/secondSignUp";
import SetMarginSlab from "layouts/authentication/setSlabMargin";
import SocialMedia from "layouts/socialMedia";

const routes = [
  {
    type: "collapse",
    name: "Publication List",
    key: "tables",
    icon: <Icon fontSize="small">newspaper</Icon>,
    route: "/Tables",
    component: <Tables />,
    selection: "publication",
  },

  {
    type: "collapse",
    name: "Social Media List",
    key: "tables-package",
    icon: <Icon fontSize="small">share</Icon>,
    route: "/Tables",
    component: <Tables />,
    selection: "package",
  },

  {
    type: "route",
    name: "Popup",
    key: "popup",
    route: "/popup",
    icon: <i className="material-icons">open_in_new</i>,
    component: <Popup />,
  },
  {
    type: "collapse",
    name: "Create User",
    key: "createUsers",
    icon: <Icon fontSize="small">person_add_alt1</Icon>,
    route: "/authentication/createUsers",
    component: <UserCreate />,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <Basic />,
  },
  {
    type: "route",
    name: "Sign Up List Form",
    key: "signuplistform",
    route: "/authentication/sign-up-list",
    component: <SecondSignUp />,
  },
  {
    type: "collapse",
    name: "Offers & Announcements ",
    key: "Offers & Announcements ",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/authentication/OfferNewsList",
    component: <OfferNewsList />,
  },
  {
    type: "collapse",
    name: "Add Genre/Disclaimer",
    key: "genre-disclaimer",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/authentication/genresDisclaimer",
    component: <GenresDisclaimer />,
  },
  {
    type: "collapse",
    name: "Add Region",
    key: "region-disclaimer",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/authentication/regionDisclaimer",
    component: <Region />,
  },
   {
    type: "collapse",
    name: "Add Social Media Platforms",
    key: "media",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/authentication/social-media",
    component: <SocialMedia />,
  },
  {
    type: "collapse",
    name: "User List",
    key: "User List",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/authentication/UserList",
    component: <UserList />,
  },

  {
    type: "collapse",
    name: "Sign Up List",
    key: "Sign Up List",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/authentication/SignUpUserList",
    component: <SignUpUserList />,
  },


  {
    type: "collapse",
    name: "Contact Form Entries",
    key: "contactUS",
    icon: <Icon fontSize="small">contact_page</Icon>,
    route: "/authentication/contactus",
    component: <ContactUs />,
  },


  {
    type: "collapse",
    name: "Career Form Entries",
    key: "Career",
    icon: <Icon fontSize="small">perm_identity</Icon>,
    route: "/authentication/carreirPage",
    component: <CarrieirPage />,
  },

  {
    type: "collapse",
    name: "Margin",
    key: "margin",
    icon: <Icon fontSize="small">margin</Icon>,
    route: "/authentication/setMargin",
    component: <SetMargin />,
  },
  {
    type: "collapse",
    name: "Margin Slabs",
    key: "margin-slab",
    icon: <Icon fontSize="small">margin</Icon>,
    route: "/authentication/setMarginSlab",
    component: <SetMarginSlab />,
  },
  {
    type: "collapse",
    name: "USD",
    key: "usd",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/authentication/setUsdPrice",
    component: <SetUsdPrice />,
  },
  // {
  //   path: "*",
  //   element: <Navigate to="/authentication/sign-in" />,
  // },
];

export default routes;
